module.exports = __webpack_public_path__ + "img/how-to-play-inner-bubble.61b2e0db.png";